import { Notifier } from '@airbrake/browser'
import { reportScopedError } from 'shared-utils/error'
import { logError } from 'shared-utils/log'

export default defineNuxtPlugin(nuxtApp => {
  // Staging or production only
  if (
    import.meta.dev ||
    !import.meta.client
  ) {
    return
  }

  // Error reporting must never be the reason a page fails to boot.
  try {
    const config = useRuntimeConfig()
    const env = config.public

    if (
      !env.AIRBRAKE_PROJECT_ID ||
      !env.AIRBRAKE_PROJECT_KEY
    ) {
      return
    }

    const airbrake = new Notifier({
      projectId: Number(env.AIRBRAKE_PROJECT_ID),
      projectKey: env.AIRBRAKE_PROJECT_KEY
    })

    if (window) {
      window.airbrake = airbrake
    }

    nuxtApp.provide('airbrake', airbrake)

    // Runs later, outside this try/catch. A failed report goes to the console, never back to Airbrake.
    nuxtApp.hook('app:error', error => {
      try {
        airbrake.notify({ error }).catch(notifyError => {
          logError('plugins::airbrake', 'Error report failed', notifyError)
        })
      } catch (hookError) {
        logError('plugins::airbrake', 'Error report failed', hookError)
      }
    })
  } catch (err) {
    const error = err as Error

    // window.airbrake was never set, so this falls through to the gated console.
    reportScopedError('plugins::airbrake', 'Initialization failed', error)
  }
})
